import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01a00c75"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "createTime" }
const _hoisted_4 = { class: "box mark" }
const _hoisted_5 = { style: {"color":"red","padding":"12px","background":"rgb(229, 246, 244)","font-weight":"600"} }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "high-light" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1))
const _hoisted_10 = { style: {"position":"relative"} }
const _hoisted_11 = {
  key: 0,
  style: {"position":"absolute","top":"0","bottom":"0","width":"100%","height":"100%","z-index":"999","background-color":"rgba(0, 0, 0, 0.1)","text-align":"center","margin-top":"1.5rem"}
}
const _hoisted_12 = { style: {"color":"red","padding":"12px","background":"rgb(229, 246, 244)","font-weight":"600"} }
const _hoisted_13 = {
  class: "bold flex",
  style: {"color":"#000000"}
}
const _hoisted_14 = { class: "van-cell__title" }
const _hoisted_15 = { style: {"font-size":"0.32rem"} }
const _hoisted_16 = { class: "high-light" }
const _hoisted_17 = {
  key: 0,
  style: {"padding":"0"}
}
const _hoisted_18 = { class: "van-cell__title" }
const _hoisted_19 = { style: {"font-size":"0.3rem"} }
const _hoisted_20 = { class: "high-light-children" }

import { ref, watch, onMounted, nextTick } from "vue";
import { useRoute } from "vue-router";
import {
  CellGroup,
  Cell,
  Tabs,
  Tab,
  Overlay,
  Loading,
  Empty,
  Collapse,
  CollapseItem,
  Icon,
} from "vant";
import { formatPercentage } from "@/utils";
import createWatermark from "@/utils/watermark";
import dayjs from "dayjs";

import request from "@/provide/fetch";


export default /*#__PURE__*/_defineComponent({
  __name: 'simCard',
  setup(__props) {

const route = useRoute();
const active = ref(0);
const field = ref("全域中心");
const productOrderPayCountAsc = ref(false); // 产品-下单成功量升序
// const orderPayRateAsc = ref(false); // 下单成功率升序
const distributorOrderPayCountAsc = ref(false); // 渠道-下单成功量升序

const visible = ref(true);
const pageData = ref<any>({});
let time = dayjs(route.params.time as string).format("YYYY-MM-DD");
const getPageData = async () => {
  const res = await request({
    url: "/api/wx/international/sales-statistics",
    method: "POST",
    data: {
      startCreateTime: time,
      endCreateTime: time,
      dept: "",
      // groupUnit: sessionStorage.getItem("openid"),
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    pageData.value = res.data;
    visible.value = true;
  } else {
    // showFailToast(res.data);
  }
};
const tabList = ref<any>([
  { title: "全域中心", disabled: false },
  { title: "电商中心", disabled: true },
  { title: "ToB渠道", disabled: true },
]);
getPageData();
const tabData = ref({});
const tabLoading = ref(false);
const handleTabData = async () => {
  tabLoading.value = true;
  tabData.value = [];
  const res = await request({
    url: "/api/wx/international/sales-statistics",
    method: "POST",
    data: {
      startCreateTime: time,
      endCreateTime: time,
      dept: field.value,
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    tabData.value = res.data;
    tabLoading.value = false;
    tabList.value = tabList.value.map((item: { disabled: boolean }) => {
      return {
        ...item,
        disabled: false,
      };
    });
    activeNames.value = [];
  } else {
    // showFailToast(res.data);
  }
};
handleTabData();
const handleChange = (name: number) => {
  if (name === 0) {
    field.value = "全域中心";
  } else if (name === 1) {
    field.value = "电商中心";
  } else {
    field.value = "ToB渠道";
  }
  tabList.value = tabList.value.map(
    (item: { disabled: boolean }, index: any) => {
      if (index === name) {
        item.disabled = false;
      } else {
        item.disabled = true;
      }
      return item;
    }
  );
  handleTabData();
};

const getUserInfo = async () => {
  return request({
    url: "/api/wx/user/getUserByOpenId",
    method: "GET",
    params: {
      openId: sessionStorage.getItem("openid"),
    },
  }).then((res) => {
    if (res.code === 200) {
      sessionStorage.setItem("name", res.data.name);
    }
  });
};
onMounted(() => {
  if (sessionStorage.getItem("name")) {
    createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
  } else {
    getUserInfo().then(() => {
      createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
    });
  }
});

const tabs = ref();
watch(visible, () => {
  nextTick(() => {
    tabs.value.resize();
  });
});
const activeNames = ref([]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "生成时间： " + _toDisplayString(_unref(dayjs)(_unref(route).params.time as string).format("YYYY-MM-DD")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.value, (item, key, index) => {
          return (_openBlock(), _createBlock(_unref(CellGroup), { key: index }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_5, " ·" + _toDisplayString(key), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (childRenItem, childRenIndex) => {
                return (_openBlock(), _createBlock(_unref(Cell), {
                  title: childRenItem.name,
                  size: "large",
                  class: "bold",
                  "title-style": { width: '120px', flex: 'inherit' },
                  key: childRenIndex
                }, {
                  label: _withCtx(() => [
                    (childRenItem.name === '激活成功量')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, "订单时间纬度"))
                      : _createCommentVNode("", true),
                    (childRenItem.name === '实际激活量')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, "激活时间纬度"))
                      : _createCommentVNode("", true)
                  ]),
                  value: _withCtx(() => [
                    _createElementVNode("span", _hoisted_8, [
                      _createTextVNode(_toDisplayString(childRenItem.type === "percentage"
                    ? _unref(formatPercentage)(childRenItem.value)
                    : childRenItem.value) + "（环比：", 1),
                      _createElementVNode("span", {
                        style: _normalizeStyle({
                    color: childRenItem.percentage >= 0 ? 'red' : 'green',
                  })
                      }, _toDisplayString(`${
                      childRenItem.percentage >= 0 ? "+" : ""
                    }${_unref(formatPercentage)(childRenItem.percentage)}`), 5),
                      _createTextVNode("） ")
                    ])
                  ]),
                  _: 2
                }, 1032, ["title"]))
              }), 128))
            ]),
            _: 2
          }, 1024))
        }), 128)),
        _hoisted_9,
        _createVNode(_unref(Tabs), {
          active: active.value,
          "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => ((active).value = $event)),
          onChange: handleChange,
          ref_key: "tabs",
          ref: tabs
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item, index) => {
              return (_openBlock(), _createBlock(_unref(Tab), {
                key: index,
                title: item.title,
                disabled: item.disabled
              }, null, 8, ["title", "disabled"]))
            }), 128)),
            _createElementVNode("div", _hoisted_10, [
              (tabLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_unref(Loading), {
                      type: "spinner",
                      color: "#1989fa"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("加载中")
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabData.value, (group, groupIndex) => {
                return (_openBlock(), _createElementBlock("div", { key: groupIndex }, [
                  _createElementVNode("p", _hoisted_12, " ·" + _toDisplayString(groupIndex), 1),
                  _createVNode(_unref(Collapse), {
                    modelValue: activeNames.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeNames).value = $event)),
                    border: false
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, itemIndex) => {
                        return (_openBlock(), _createBlock(_unref(CollapseItem), {
                          key: itemIndex,
                          name: item.name + item.value,
                          border: false,
                          disabled: !item.headValueDataList
                        }, {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("span", _hoisted_15, _toDisplayString(item.name) + "： ", 1),
                                _createElementVNode("span", _hoisted_16, [
                                  _createTextVNode(_toDisplayString(item.type === "percentage"
                              ? _unref(formatPercentage)(item.value)
                              : item.value) + " （环比：", 1),
                                  _createElementVNode("span", {
                                    style: _normalizeStyle({
                              color: item.percentage >= 0 ? 'red' : 'green',
                            })
                                  }, _toDisplayString(`${
                                item.percentage >= 0 ? "+" : ""
                              }${_unref(formatPercentage)(item.percentage)}`), 5),
                                  _createTextVNode("） ")
                                ])
                              ])
                            ])
                          ]),
                          "right-icon": _withCtx(() => [
                            (
                        item.headValueDataList &&
                        item.headValueDataList.length > 0
                      )
                              ? (_openBlock(), _createBlock(_unref(Icon), {
                                  key: 0,
                                  name: "arrow-down"
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          default: _withCtx(() => [
                            (
                      item.headValueDataList &&
                      item.headValueDataList.length > 0
                    )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.headValueDataList, (thirdLevelItem, thirdLevelIndex) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      style: {"color":"#000000","padding-bottom":"10px"},
                                      class: "bold flex",
                                      key: thirdLevelIndex
                                    }, [
                                      _createElementVNode("div", _hoisted_18, [
                                        _createElementVNode("span", _hoisted_19, _toDisplayString(thirdLevelItem.name) + "： ", 1),
                                        _createElementVNode("span", _hoisted_20, [
                                          _createTextVNode(_toDisplayString(thirdLevelItem.type === "percentage"
                              ? _unref(formatPercentage)(thirdLevelItem.value)
                              : thirdLevelItem.value) + " （环比：", 1),
                                          _createElementVNode("span", {
                                            style: _normalizeStyle({
                              color:
                                thirdLevelItem.percentage >= 0
                                  ? 'red'
                                  : 'green',
                            })
                                          }, _toDisplayString(`${
                                thirdLevelItem.percentage >= 0 ? "+" : ""
                              }${_unref(formatPercentage)(thirdLevelItem.percentage)}`), 5),
                                          _createTextVNode("） ")
                                        ])
                                      ])
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["name", "disabled"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["modelValue"])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["active"])
      ])
    ], 512), [
      [_vShow, visible.value]
    ]),
    _createVNode(_unref(Overlay), {
      class: "overlay",
      show: !visible.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Loading), { type: "spinner" })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})